import { useTranslation } from "react-i18next";
import { Stack, Typography } from "@mui/material";
import SubActionButton from "@quest_editor/components/Buttons/SubActionButton";

function EligibleSearchField({
  eligibleCount,
  onSearch,
}: {
  eligibleCount: number;
  onSearch: () => void;
}) {
  const { t } = useTranslation("questEditor");

  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      <SubActionButton onClick={onSearch}>
        {t("quest_edit_target.button.extract_number_by_conditions")}
      </SubActionButton>
      <Typography color="primary">
        {t(
          "quest_edit_target.field.number_of_deliveries.search_eligible_people_label",
          { number: eligibleCount.toLocaleString() },
        )}
      </Typography>
    </Stack>
  );
}

export default EligibleSearchField;
